import React from 'react';
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';

import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';

class Users extends React.Component {
  constructor(props) {
    super(props);
    this.state = { users: [], columns: [], DataisLoaded: false };
  }

  componentDidMount() {
    this.refreshList();
  }

  componentDidUpdate() {
    // this.refreshList();
  }

  refreshList() {
    fetch('http://gpsdogstracking.com/site/readclanovi.php')
      .then((res) => res.json())
      .then((json) => {
        this.setState({
          users: json,
          DataisLoaded: true
        });
        console.log(json);
      });
  }

  render() {
    const { DataisLoaded, users, columns } = this.state;
    if (!DataisLoaded)
      return (
        <div>
          <h1> Loading data... </h1>
        </div>
      );
    return (
      <div className="App">
        <h1> Devices </h1>
		
		  <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
			  <thead>
				<tr>
					<th scope="col">ID</th>
					<th scope="col">Naziv</th>
					<th scope="col">Naziv</th>
					<th scope="col">Naziv</th>
					<th scope="col">Naziv</th>
					<th scope="col">Naziv</th>
					<th scope="col">Naziv</th>
					<th scope="col">Naziv</th>
					<th scope="col">Naziv</th>
				</tr>
			  </thead>
			  {users.map((user) => (
			        <TableRow hover role="checkbox">
                        <TableCell>
						{user.id}
                        </TableCell>
						
						<TableCell>
						{user.ime}
                        </TableCell>
						
						<TableCell>
						{user.prezime}
                        </TableCell>
						
						<TableCell>
						{user.adresa}
                        </TableCell>
						
						<TableCell>
						{user.telefon}
                        </TableCell>
						
						<TableCell>
						{user.lovacko_drustvo}
                        </TableCell>
						
						<TableCell>
						{user.maticni_broj}
                        </TableCell>
						
						<TableCell>
						{user.lovacki_list}
                        </TableCell>
						
						<TableCell>
						{user.ime}
                        </TableCell>
                    </TableRow>
					 ))}
              </Table>
            </TableContainer>
          </Scrollbar>
      </div>
    );
  }
}

export default Users;